import React from "react";
import { IconProps } from "./type";
import { StyledPath, StyledSvg } from "./style";

export const Trash = ({ size = 24, color = "staticBlack", $svgStyle, $pathStyle }: IconProps) => {
  return (
    <StyledSvg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      $svgStyle={$svgStyle!}
    >
      <StyledPath
        d="M9.2013 19.2514C8.80906 19.2514 8.55287 19.0188 8.53296 18.6437L8.25741 9.00656C8.24499 8.63711 8.49955 8.39728 8.90423 8.39728C9.28475 8.39728 9.5501 8.62985 9.56085 8.99765L9.85302 18.6405C9.86377 19.0099 9.60175 19.2514 9.2013 19.2514ZM12.0008 19.2514C11.6053 19.2514 11.3358 19.0131 11.3358 18.6453V9.00333C11.3358 8.63552 11.6053 8.39728 12.0008 8.39728C12.3947 8.39728 12.6717 8.63552 12.6717 9.00333V18.6453C12.6717 19.0131 12.3947 19.2514 12.0008 19.2514ZM14.8062 19.2514C14.4058 19.2514 14.1437 19.0099 14.1545 18.6405L14.4392 9.00492C14.4516 8.62985 14.7153 8.39728 15.0958 8.39728C15.5005 8.39728 15.755 8.63711 15.7426 9.00656L15.4671 18.6437C15.4471 19.0188 15.191 19.2514 14.8062 19.2514ZM7.85294 6.07761H9.538V4.23672C9.538 3.77778 9.86874 3.48334 10.3771 3.48334H13.6079C14.1163 3.48334 14.447 3.77778 14.447 4.23672V6.07761H16.1321V4.15447C16.1321 2.79911 15.241 2 13.7281 2H10.257C8.74406 2 7.85294 2.79911 7.85294 4.15447V6.07761ZM3.80802 7.04192H20.1995C20.6494 7.04192 21 6.69501 21 6.25823C21 5.82465 20.6494 5.48501 20.1995 5.48501H3.80802C3.36558 5.48501 3 5.82465 3 6.25823C3 6.70228 3.36558 7.04192 3.80802 7.04192ZM7.80765 22H16.1999C17.5975 22 18.5053 21.1693 18.5708 19.811L19.1984 6.85738H4.80159L5.4367 19.8183C5.5039 21.1766 6.39501 22 7.80765 22Z"
        fill-opacity="0.85"
        color={color!}
        $pathStyle={$pathStyle!}
      />
    </StyledSvg>
  );
};
